
import { defineComponent, onMounted, PropType, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheTextarea from '@/common/components/UI/TheTextarea/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// realisation
import { surveys } from '@/core/realisations/surveys.realisation'
import { FullSurveyT, SurveyPayloadT, SurveyUpdatePayloadT } from '@/core/types/survey.types'

// composable
import useNotifications from '@/common/composable/useNotifications'
import { useRouter } from 'vue-router'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-textarea': TheTextarea,
        'the-button': TheButton,
        checkbox: Checkbox,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Object as PropType<FullSurveyT>,
            default: null,
        },
        surveyId: {
            type: Number,
            default: null,
        },
    },
    setup(props) {
        const notifications = useNotifications()
        const router = useRouter()

        const state = reactive({
            is_loading: false,
            title: null as string | null,
            description: null as string | null,
            isActive: 1,
        })

        const validation_rules = {
            title: { required },
            description: { required },
        }

        const state_form$ = useVuelidate(validation_rules, state)

        onMounted(() => {
            if (props.isUpdate && props.initialValue) {
                state.title = props.initialValue.title
                state.description = props.initialValue.description
                state.isActive = props.initialValue.isActive
            }
        })

        const onSubmit = async () => {
            state_form$.value.$touch()

            if (state_form$.value.$invalid || !state.title || !state.description) {
                return
            }

            try {
                state.is_loading = true

                if (!props.isUpdate) {
                    const payload: SurveyPayloadT = {
                        title: state.title,
                        description: state.description,
                    }

                    const response = await surveys.createSurvey(payload)
                    notifications.notify({ title: 'Опрос создан', type: 'success' })
                    router.push(`/surveys-update/${response.data.id}`)
                } else {
                    if (!props.surveyId) return

                    const payload: SurveyUpdatePayloadT = {
                        title: state.title,
                        description: state.description,
                        isActive: state.isActive,
                    }

                    await surveys.updateSurvey(props.surveyId, payload)
                    notifications.notify({ title: 'Опрос отредактирован', type: 'success' })
                }
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При создании опроса произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return { state, state_form$, onSubmit }
    },
})
